module.exports = __webpack_public_path__ + "static/media/ops3.png.88544a9b.jpg";